<template>
  <MetricTile
    v-if="density === 'default'"
    :loading="loading"
    :no-data="!metric || !metric.count"
    icon="fa-solid fa-user-plus"
    :show-duration="false"
    color="blue"
  >
    <template #title>Students Signed Up</template>
    <template #metric-title>Students</template>
    <template #metric>
      {{ metric.count }}
    </template>
  </MetricTile>
  <MiniMetricTile v-else-if="density === 'compact'" color="blue" :loading="loading">
    <template #icon>
      fa-solid fa-user-plus
    </template>
    <template #metric>
      {{ metric?.count || 0 }}
    </template>
    <template #title>
      Students Signed Up
    </template>
  </MiniMetricTile>
</template>

<script setup lang="ts">
import MetricTile from "@/components/Metrics/MetricTile.vue";
import {useMetricTile} from "@/composables/useMetricTile";
import {PropType} from "vue";
import MiniMetricTile from "@/components/Metrics/MiniMetricTile.vue";

const {metric, loading} = useMetricTile<{
  count: number;
}>("users-created-over-time");

defineProps({
  density: {
    type: String as PropType<"default" | "compact" | "comfortable">,
    default: "default"
  },
});
</script>
